<template>
<div class="home-out">
  <div class="home-cont">

  <div>
    <!-- 棋盘开始 -->
    <div :class="{'k-title': true, 'red': now == 2, 'blue': now == 1}">{{now == 1 ? '蓝方操作' : '红方操作'}}</div>
    <div class="k-out" @click="forecastUn">
      <!-- 背景框子开始 -->
      <div class="k-cont">
        <ul>
          <li class="k-no"></li>
          <li></li>
          <li></li>
          <li class="k-no k-left"></li>
        </ul>
        <ul>
          <li class="k-no"></li>
          <li></li>
          <li></li>
          <li class="k-no k-left"></li>
        </ul>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li class="k-right"></li>
        </ul>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li class="k-right"></li>
        </ul>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li class="k-right"></li>
        </ul>
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li class="k-right"></li>
        </ul>
      </div>
      <!-- 背景框子结束 -->

      <!-- 棋子开始 -->
      <ul class="q-cont">
        <li v-for="(item, index) in qList" :key="index" 
          :class="{'q-boss': item.type == 1, 'q-little': item.type == 2, 'q-warrior': item.type == 3, 'on': item.id == qOn}"
          :style="{'left': item.x * 100 + 'px', 'top': item.y * 100 + 'px'}"
          @click.stop="forecast(item)"
        ></li>
      </ul>
      <!-- 棋子结束 -->

      <!-- 预测开始 -->
      <ul class="f-cont">
        <li v-for="(item, index) in fList" :key="index" 
          :style="{'left': item.x * 100 + 'px', 'top': item.y * 100 + 'px'}" 
          @click.stop="qCtrl(item)"></li>
      </ul>
      <!-- 预测结束 -->
    </div>
    <!-- 棋盘结束 -->
  </div>


  </div>
</div>
</template>

<script>
export default {
	name: 'home',
	components: {
		
  },
  data () {
    return {
      qList: [], // 棋子列表
      qOn: '', // 选中的棋子ID
      qObj: {}, // 选中的棋子ID

      now: 1, // （1蓝方操作， 2红方操作）

      fList: [], // 预测点列表
      

      // 初始化棋子(1boss, 2小兵， 3英雄)
      initList: [{
        x: 0,
        y: 6,
        type: 3,
        id: 1
      }, {
        x: 1,
        y: 6,
        type: 3,
        id: 2
      }, {
        x: 2,
        y: 6,
        type: 3,
        id: 3
      }, {
        x: 3,
        y: 6,
        type: 3,
        id: 4
      }, {
        x: 4,
        y: 6,
        type: 3,
        id: 5
      }, {
        x: 1,
        y: 0,
        type: 2,
        id: 6
      }, {
        x: 2,
        y: 0,
        type: 2,
        id: 7
      }, {
        x: 3,
        y: 0,
        type: 2,
        id: 8
      }, {
        x: 1,
        y: 1,
        type: 2,
        id: 9
      }, {
        x: 2,
        y: 1,
        type: 1,
        id: 10
      }, {
        x: 3,
        y: 1,
        type: 2,
        id: 11
      }, {
        x: 0,
        y: 2,
        type: 2,
        id: 12
      }, {
        x: 1,
        y: 2,
        type: 2,
        id: 13
      }, {
        x: 2,
        y: 2,
        type: 2,
        id: 14
      }, {
        x: 3,
        y: 2,
        type: 2,
        id: 15
      }, {
        x: 4,
        y: 2,
        type: 2,
        id: 16
      }, {
        x: 0,
        y: 3,
        type: 2,
        id: 17
      }, {
        x: 1,
        y: 3,
        type: 2,
        id: 18
      }, {
        x: 2,
        y: 3,
        type: 2,
        id: 19
      }, {
        x: 3,
        y: 3,
        type: 2,
        id: 20
      }, {
        x: 4,
        y: 3,
        type: 2,
        id: 21
      }, {
        x: 0,
        y: 4,
        type: 2,
        id: 22
      }, {
        x: 1,
        y: 4,
        type: 2,
        id: 23
      }, {
        x: 2,
        y: 4,
        type: 2,
        id: 24
      }, {
        x: 3,
        y: 4,
        type: 2,
        id: 25
      }, {
        x: 4,
        y: 4,
        type: 2,
        id: 26
      }],
    }
  },
  mounted () {
    this.initF()
  },
  methods: {
    /**
     * 初始化
     */
    initF () {
      this.qList = [...this.initList];
      this.now = 1;
      this.forecastUn();
    },
    /**
     * 操作
     */
    qCtrl (obj) {
      const vm = this;
      // 吃掉原来的
      this.qList = this.qList.filter(e => {
        if(e.x == obj.x && e.y == obj.y){
          return false;
        }
        return true;
      })
      // 移动现在的
      this.qList = this.qList.map(e => {
        let obj1 = e;
        if(obj1.id == vm.qOn){
          obj1.x = obj.x;
          obj1.y = obj.y;
        }
        return obj1;
      })
      // 恢复预测状态
      this.forecastUn();
      // 切换操作方
      this.now == 1 ? this.now = 2 : this.now = 1;
    },
    forecastUn (){
      this.qOn = ''; // 亮显当前操作棋子
      this.qObj = {}
      this.fList = [];
    },
    /**
     * 预测轨迹
     */
    forecast ({x,y,type,id}) {
      const vm = this;
      // 当前操作者
      if(this.now == 1){
        if(type == 3){
          return;
        }
      }else{
        if(type == 1 || type == 2){
          return;
        }
      }
      this.qOn = id; // 亮显当前操作棋子
      this.qObj = {x,y,type,id}
      this.fList = []; // 置空操作点
      let list = [];
      if(type == 1){
        // boss
        list = [{
          x: x+1,
          y: y+1
        }, {
          x: x+1,
          y: y-1
        },{
          x: x-1,
          y: y+1
        },{
          x: x-1,
          y: y-1
        }]
        list = list.filter(vm.limit);
        list = list.filter(vm.boosZ);
      }else if(type == 2){
        // 小兵
        list = [{
          x: x+1,
          y: y
        }, {
          x: x-1,
          y: y
        },{
          x: x,
          y: y+1
        },{
          x: x,
          y: y-1
        }]
        list = list.filter(vm.limit);
        list = list.filter(vm.littleZ);
      }else if(type == 3){
        // 英雄
        list = [{
          x: x+1,
          y: y
        }, {
          x: x+2,
          y: y
        },{
          x: x-1,
          y: y
        },{
          x: x-2,
          y: y
        },{
          x: x,
          y: y+1
        },{
          x: x,
          y: y+2
        },{
          x: x,
          y: y-1
        },{
          x: x,
          y: y-2
        }]
        list = list.filter(vm.limit);
        list = list.filter(vm.warriorZ);
      }
      this.fList = list;
    },
    /**
     * 超出界限判断
     */
    limit ({x, y}) {
      if(y < 2 && y>=0 && x>=1 && x <= 3){
        return true;
      }else if(y <= 6 && y >= 2 && x <= 4 && x >= 0){
        return true;
      }else{
        return false
      }
    },
    /**
     * boos阻塞判断
     */
    boosZ ({x, y}) {
      let ok = true;
      this.qList.forEach(e => {
        if(e.type == 2 && e.x == x && e.y == y){
          ok = false
        }
      })
      return ok;
    },
    /**
     * 小兵阻塞判断
     */
    littleZ ({x, y}) {
      let ok = true;
      this.qList.forEach(e => {
        if(e.x == x && e.y == y){
          ok = false
        }
      })
      return ok;
    },
    /**
     * 英雄阻塞判断
     */
    warriorZ ({x, y}) {
      const vm = this;
      let ok = true;
      if(Math.abs(x - vm.qObj.x) > 1 || Math.abs(y - vm.qObj.y) > 1){
        // 吃
        ok = false;
        this.qList.forEach(e => {
          if((e.type == 1 || e.type == 2) && e.x == x && e.y == y){
            ok = true
            if(x < vm.qObj.x){
              vm.qList.forEach(p => {
                if(p.x == x+1 && p.y == y){
                  ok = false
                }
              })
            }else if(x > vm.qObj.x){
              vm.qList.forEach(p => {
                if(p.x == x-1 && p.y == y){
                  ok = false
                }
              })
            }else if(y < vm.qObj.y){
              vm.qList.forEach(p => {
                if(p.x == x && p.y == y + 1){
                  ok = false
                }
              })
            }else if(y > vm.qObj.y){
              vm.qList.forEach(p => {
                if(p.x == x && p.y == y - 1){
                  ok = false
                }
              })
            }
          }
        })
      }else{
        // 移动
        this.qList.forEach(e => {
          if(e.x == x && e.y == y){
            ok = false
          }
        })
      }
      return ok;
    },
    
    
    


  }
}
</script>

<style lang="scss" scoped>
.home-out{
  height: 100%;
  overflow-y: scroll;
}
.home-cont{
  min-height: 100vh;
  display: flex;
  justify-content:center;
  align-items:center;
  height: 840px;
}
.k-out{
  padding: 100px;
  background-color: #fff;
  position: relative;
  width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
}
.k-cont{
  ul{
    display: flex;
    padding: 0;
    margin: 0;
    li{
      height: 100px;
      width: 100px;
      box-sizing: border-box;
      border-top: 1px solid rgba(0,0,0,0.4);
      border-left: 1px solid rgba(0,0,0,0.4);
    }
    .k-no{
      border-color: transparent;
    }
    .k-right{
      border-right: 1px solid rgba(0,0,0,0.4);
    }
    .k-left{
      border-left: 1px solid rgba(0,0,0,0.4);
    }
    &:last-child li{
      border-bottom: 1px solid rgba(0,0,0,0.4);
    }
  }
}
.q-cont{
  position: absolute;
  left: 100px;
  top: 100px;
  li{
    position: absolute;
    left: 0px;
    top: 0px;
    margin-left: -11px;
    margin-top: -11px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 0 3px #ccc, 0 2px 2px #eee inset;
    cursor: pointer;
  }
  .q-boss{
    background: #2196f3;
    border: 1px solid #2196f3;
    box-shadow: 0 0 3px #2196f3, 0 2px 2px #2196f3b3 inset;
  }
  .q-little{
    background: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 0 3px #ccc, 0 2px 2px #eee inset;
  }
  .q-warrior{
    background: #ff5252;
    border: 1px solid #ff5252;
    box-shadow: 0 0 3px #ff5252, 0 2px 2px #ff525282 inset;
  }
}
.f-cont{
  position: absolute;
  z-index: 10;
  left: 100px;
  top: 100px;
  li{
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 30px;
    margin-left: -15px;
    margin-top: -15px;
    border-radius: 50%;
    background-color: rgba(76, 175, 80, 0.3);
    cursor: pointer;
  }
}

.on{
  box-shadow: 0 0 10px !important;;
}
.k-title{
  width: 600px;
  margin: 0 auto;
  text-align: center;
  height: 40px;
  line-height: 40px;
  color: #fff;
}
.red{
  background-color: #ff5252;
}
.blue{
  background-color: #2196f3;
}
</style>
